module.exports = __webpack_public_path__ + "static/media/open-sans-v15-latin-italic.db70d0b9.woff";